import notificationsApi from './notificationsApi';

class NotificationsService {
  /**
   * Obter notificações do usuário (com fallback seguro)
   */
  async getNotifications(skip = 0, take = 20) {
    try {
      const response = await notificationsApi.get('/Notifications', {
        params: { skip, take }
      });
      return response.data || [];
    } catch (error) {
      console.warn('[Notifications] Failed to fetch notifications:', error.message);
      return []; // Retorna array vazio em caso de erro
    }
  }

  /**
   * Obter contador de notificações não lidas
   */
  async getUnreadCount() {
    try {
      const response = await notificationsApi.get('/Notifications/unread/count');
      return response.data?.count || 0;
    } catch (error) {
      console.warn('[Notifications] Failed to fetch unread count:', error.message);
      return 0; // Retorna 0 em caso de erro
    }
  }

  /**
   * Marcar notificação como lida
   */
  async markAsRead(notificationId) {
    try {
      await notificationsApi.patch(`/Notifications/${notificationId}/read`);
      return true;
    } catch (error) {
      console.warn('[Notifications] Failed to mark as read:', error.message);
      return false;
    }
  }

  /**
   * Obter uma notificação por ID
   */
  async getNotificationById(notificationId) {
    try {
      const response = await notificationsApi.get(`/Notifications/${notificationId}`);
      return response.data || null;
    } catch (error) {
      console.warn('[Notifications] Failed to fetch notification:', error.message);
      return null;
    }
  }

  /**
   * Deletar notificacao
   */
  async deleteNotification(notificationId) {
    try {
      await notificationsApi.delete(`/Notifications/${notificationId}`);
      return true;
    } catch (error) {
      console.warn('[Notifications] Failed to delete notification:', error.message);
      return false;
    }
  }

  // --- Push Subscription ---

  /**
   * Obter chave publica VAPID do servidor
   */
  async getVapidPublicKey() {
    try {
      const response = await notificationsApi.get('/PushSubscriptions/vapid-key');
      return response.data?.publicKey || null;
    } catch (error) {
      console.warn('[Notifications] Failed to get VAPID key:', error.message);
      return null;
    }
  }

  /**
   * Registrar push subscription no backend
   */
  async subscribePush(endpoint, p256dh, auth) {
    try {
      const response = await notificationsApi.post('/PushSubscriptions', {
        endpoint,
        p256dh,
        auth
      });
      return response.data?.id || null;
    } catch (error) {
      console.warn('[Notifications] Failed to subscribe push:', error.message);
      return null;
    }
  }

  /**
   * Remover push subscription por endpoint URL
   */
  async unsubscribePushByEndpoint(endpoint) {
    try {
      await notificationsApi.delete('/PushSubscriptions/by-endpoint', {
        data: { endpoint }
      });
      return true;
    } catch (error) {
      console.warn('[Notifications] Failed to unsubscribe push:', error.message);
      return false;
    }
  }
}

export const notificationsService = new NotificationsService();
